import styled from 'styled-components'
import { defaultTheme } from '../../theming/data/defaultTheme'
import border from '../../tokens/v2/border'
import colors from '../../tokens/v2/colors'
import { composeTheme } from '../../utils/compose-theme'

export const SideMenuAlt = styled.div.attrs((props) => composeTheme(props))`
  background-color: ${(props) => props.theme.sideMenuAlt.background};
  border-right: ${(props) => props.theme.sideMenuAlt.borderColor};
  display: inline-block;
  width: ${(props) =>
    props.theme.collapsed ? '5rem' : props.theme.sideMenuAlt.width} !important;
  height: ${(props) => props.theme.sideMenuAlt.height};

  padding: ${(props) => `
    ${props.theme.sideMenuAlt.paddingTop}
    ${props.theme.sideMenuAlt.paddingRight}
    ${props.theme.sideMenuAlt.paddingBottom}
    ${props.theme.sideMenuAlt.paddingLeft}
  `};
  transition: width 0.25s ease;
`

export const FooterContainer = styled.div.attrs((props) => composeTheme(props))`
  max-width: ${(props) =>
    props.theme.collapsed ? '8.1rem' : '100%'} !important;
  transition: max-width 0.25s ease;
`

export const Container = styled.section`
  display: inline-block;
  position: relative;
`

export const Separator = styled.div``

export const ContentWrapper = styled.div.attrs((props) => composeTheme(props))`
  height: calc(100% - 6rem);
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  overflow-y: overlay;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${colors.gray300} transparent;
  &::-webkit-scrollbar {
    z-index: 999;
    width: 2rem;
    height: 2rem;
  }
  &::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.sideMenuAlt.background};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.gray400};
    border: ${border.width.micro} solid
      ${(props) => props.theme.sideMenuAlt.background};
    border-radius: ${border.radius.giant};
    &:hover {
      background-color: ${colors.gray500};
    }
  }
`

SideMenuAlt.defaultProps = defaultTheme
